import axios from "axios";
import { SERVER_URL } from "../constants/server";

export const getRedcapLogs = () =>
  axios.get(SERVER_URL + "/api/logs/redcap-perms", {
    withCredentials: true,
  });
